import { useNavbarHeight } from "../../utils/contexts/NavbarContext";
import { scrollToIdWithOffset } from "../../lib/scrolling/ScrollToIdWithOffset";
import styles from "./FooterNav.module.css";

interface FooterLink {
  sectionId: string;
  linkName: string;
}

const footerLinkList: FooterLink[] = [
  { sectionId: "about", linkName: "About Us" },
  { sectionId: "featuredMenu", linkName: "Featured Menu" },
  { sectionId: "testimonial", linkName: "Testimonials" },
  { sectionId: "openingHours", linkName: "Opening Hours" },
  { sectionId: "delivery", linkName: "Delivery" },
  { sectionId: "partyTray", linkName: "Party Tray" },
];

function FooterNav() {
  const { navbarHeight } = useNavbarHeight();

  return (
    <nav className={styles.footerNav} aria-label="Footer navigation">
      <ul className={styles.linkList}>
        {footerLinkList.map((link) => (
          <li key={link.sectionId}>
            <a
              href={`#${link.sectionId}`}
              className={styles.footerLink}
              onClick={(e) => {
                scrollToIdWithOffset(link.sectionId, e, navbarHeight);
              }}
            >
              {link.linkName}
            </a>
          </li>
        ))}

        <li className={styles.logoItem}>
          <a
            href="#welcome"
            className={styles.logoLink}
            onClick={(e) => {
              scrollToIdWithOffset("welcome", e, navbarHeight);
            }}
            aria-label="Back to top"
          >
            <img
              className={styles.logo}
              src="/aak-logo-removebg.png"
              alt="Alo Asian Kitchen logo"
            />
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;